import { NgModule } from '@angular/core';
import { BixiColorPickerModule } from '@bixi/core/color-picker';
import { BixiEditableTableModule } from '@bixi/core/editable-table';
import { BixiFilterModule } from '@bixi/core/filter';
import { BixiFormModule } from '@bixi/core/form';
import { BixiI18nModule } from '@bixi/core/i18n';
import { BixiImageModule } from '@bixi/core/image';
import { BixiLayoutModule } from '@bixi/core/layout';
import { BixiTableModule } from '@bixi/core/table';
import { BixiTagSelectModule } from '@bixi/core/tag-select';
import { BixiTimeModule } from '@bixi/core/time';

const MODULES = [
  BixiLayoutModule,
  BixiTimeModule,
  BixiFilterModule,
  BixiTableModule,
  BixiFormModule,
  BixiImageModule,
  BixiI18nModule,
  BixiEditableTableModule,
  BixiTagSelectModule,
  BixiColorPickerModule
];

@NgModule({ exports: MODULES })
export class BixiCoreModule {
}
